import config from "../config/env";
import React from "react";
import CareScreener from "../components/care-screener/CareScreener";

const TYPEFORM_ID = config.env.REACT_APP_PCSCREENER_TYPE_FORM_ID;
const TYPEFORM_PATH = "pcscreener";
const CONTINUE_TO_BOOK_CONSULT_QUESTION_REF = "phoneNumber-fieldRef";

export default function PCScreener() {
  return (
    <CareScreener
      typeformId={TYPEFORM_ID}
      typeformPath={TYPEFORM_PATH}
      allowAppointmentScheduling={true}
      accountCreationPredicate={{ tfQuestionRefShown: CONTINUE_TO_BOOK_CONSULT_QUESTION_REF }}
    />
  );
}
